export const AUTH_REDIRECT_PARAM = 'redirect'
const AUTH_PATH = '/authenticate'

export const getSafeRedirectPath = (search: string, fallbackPath: string): string => {
  const initialRedirect = new URLSearchParams(search).get(AUTH_REDIRECT_PARAM)

  if (!initialRedirect) {
    return fallbackPath
  }

  let redirect: string = initialRedirect

  for (let i = 0; i < 5; i += 1) {
    if (!redirect.startsWith('/') || redirect.startsWith('//')) {
      return fallbackPath
    }

    const parsed: URL = new URL(redirect, window.location.origin)

    if (parsed.pathname !== AUTH_PATH) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`
    }

    const nestedRedirect: string | null = parsed.searchParams.get(AUTH_REDIRECT_PARAM)

    if (!nestedRedirect) {
      return fallbackPath
    }

    redirect = nestedRedirect
  }

  return fallbackPath
}

export const buildAuthRedirectPath = (authPath: string, targetPath: string): string => {
  const params = new URLSearchParams()

  params.set(AUTH_REDIRECT_PARAM, getSafeRedirectPath(`?${AUTH_REDIRECT_PARAM}=${encodeURIComponent(targetPath)}`, '/'))

  return `${authPath}?${params.toString()}`
}
